import { goerli, mainnet } from '@wagmi/chains'
import { modalConnectors, walletConnectProvider } from '@web3modal/ethereum'
import { configureChains, createClient } from 'wagmi'

import { Deferred } from '@/lib/deferred'
import { Web3ProviderContext } from '@/model/cryptoModel'

export const chains = [mainnet, goerli]
export const projectId = process.env.NEXT_PUBLIC_PROJECT_ID!

export const createWagmiClient = () => {
  const { provider } = configureChains(chains, [walletConnectProvider({ projectId })])
  return createClient({
    autoConnect: true,
    connectors: modalConnectors({ version: '2', appName: 'web3Modal', chains, projectId }),
    provider,
  })
}

export const deferred = new Deferred<Web3ProviderContext>()
